import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  Spinner,
  IconButton,
} from "@material-tailwind/react";

import {
  IoMdArrowDropleftCircle,
  IoMdArrowDroprightCircle,
} from "react-icons/io";

import ReportDetails from "../ReportDetails";
import StockInfo from "../StockInfo";
import ReportCard from "components/reportCard";

import { socket } from "socket";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getAllReportsListApi } from "api/gestionStock";
import { updateReportDataApi } from "api/gestionStock";
import { getAllProductsEscompteApi } from "api/products";

function BeforeInvoce({ selected, filterInputs, accessList }) {
  const [openReportDetails, setOpenReportDetails] = useState(false);
  const [openStockInfo, setOpenStockInfo] = useState(false);

  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [reportsList, setReportsList] = useState([]);
  const [isLoading, setIsLoading] = useState([]);

  const [active, setActive] = useState(1);
  const [currentPagination, setCurrentPagination] = useState(1);

  const [numberOfPages, setNumberOfPages] = useState(0);
  const [numberOfPaginations, setNumberOfPaginations] = useState(0);
  const [numberOfReports, setNumberOfReports] = useState(0);

  const [selectedReportId, setSelectedReportId] = useState({})

  const [productsEscompte, setProductsEscompte] = useState([])

  useEffect(() => {
    socket.on('reloadStockManagementsBiReports', () => {
      getInitialData(1, currentYear, filterInputs.MP, filterInputs.clientName, filterInputs.etatMagasin, "", "", "", "");
    });

    getInitialData(1, currentYear, filterInputs.MP, filterInputs.clientName, filterInputs.etatMagasin, "", "", "", "");
    setActive(1);
    setCurrentPagination(1)
  }, [selected, filterInputs]);

  const getInitialData = async (
    page,
    currentYear,
    MP,
    clientName,
    etatMagasin,
    EtatBonLivraison,
    EtatFacturation,
    EtatMagasinierTwo,
    EtatValidationB
  ) => {
    try {
      setIsLoading(true);
      const reportsData = await getAllReportsListApi(
        page,
        currentYear,
        MP,
        clientName,
        etatMagasin,
        EtatBonLivraison,
        EtatFacturation,
        EtatMagasinierTwo,
        EtatValidationB
      );
      setReportsList(reportsData);

      setNumberOfPages(reportsData.pagination.numberOfPages);
      setNumberOfPaginations(reportsData.pagination.numberOfPaginations);
      setNumberOfReports(reportsData.pagination.numberOfCollections);

      const productsEscompteData = await getAllProductsEscompteApi()
      setProductsEscompte(productsEscompteData)
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenReportDetails = (id) => {
    if(accessList.Read) {
      setSelectedReportId(id)
      setOpenReportDetails(!openReportDetails);
    }
  };

  const handleValidateModale = (id) => {
    if(accessList.Validation) {
      setSelectedReportId(id)
      setOpenStockInfo(!openStockInfo);
    }
  };

  const handleCancelReport = (reportID) => {
    try {
      if(accessList.Validation) {
        withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Voulez-vous vraiment annuler cette opération ?",
          confirmButtonText: "Annuler",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const updatedObject = {
              EtatMagasinier: "A",
            };
            await updateReportDataApi(reportID, updatedObject)
            getInitialData(active, currentYear, filterInputs.MP, filterInputs.clientName, filterInputs.etatMagasin, "", "", "", "")
            Swal.fire("Annulée", "", "success");
          }
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getItemProps = (index) => ({
    variant: active === index ? "filled" : "text",
    color: "gray",
    onClick: () => {
      getInitialData(index, currentYear, filterInputs.MP, filterInputs.clientName, filterInputs.etatMagasin, "", "", "", "");
      setActive(index);
    },
  });

  const next = () => {
    if (currentPagination === numberOfPaginations) return;
    setCurrentPagination(currentPagination + 1);
  };

  const prev = () => {
    if (currentPagination === 1) return;
    setCurrentPagination(currentPagination - 1);
  };

  const hadleShowToast = (type, message) => {

  };

  const handlePopupHandler = (type) => {
    if(type === 'reload') {
      setOpenStockInfo(!openStockInfo)
      getInitialData(active, currentYear, filterInputs.MP, filterInputs.clientName, filterInputs.etatMagasin, "", "", "", "")
    }
  }

  const checkIfAllEscompteLessThan20P = (object) => {
    // productsEscompte
    const escompteArr = []
    Object.entries(object).map(([key, value]) => {
      value.produits.map(products => {
        const productEscompteDetails = productsEscompte.find(el => el.Code === products.Code)
        if(productEscompteDetails?.Remise && productEscompteDetails?.Remise !== "")
          escompteArr.push(parseFloat(productEscompteDetails.Remise))
      })
    })

    const isLessThan20 = (escompteValue) => escompteValue <= 20;
    return escompteArr.every(isLessThan20)
  }

  return (
    <>
      <div style={{ height: "55vh", overflowY: "scroll" }}>
        <Dialog
          size="xl"
          open={openReportDetails}
          handler={handleOpenReportDetails}
        >
          <DialogHeader>
            <p className="w-full text-center">Vente (s)</p>
          </DialogHeader>
          <DialogBody>
            <ReportDetails typeOf="BI" selectedReportId={selectedReportId} accessList={accessList} />
          </DialogBody>
        </Dialog>

        <Dialog size="xl" open={openStockInfo} handler={handleValidateModale}>
          <DialogHeader>
            <p className="w-full text-center">Informations sur le stock</p>
          </DialogHeader>
          <DialogBody>
            <StockInfo selectedReportId={selectedReportId} popupHandler={handlePopupHandler} showToast={hadleShowToast} accessList={accessList} />
          </DialogBody>
        </Dialog>

        {isLoading ? (
          <div className="flex w-full items-center justify-center py-10">
            <Spinner className="h-12 w-12" />
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-3 pb-2 pr-1 lg:grid-cols-2">
            {reportsList?.data.map((el) => {
              // escompte checks → a single, focused inline alert
              const rapportKey = Object.getOwnPropertyNames(el.Rapport)[0];
              const produits = el.Rapport[rapportKey]?.produits || [];
              const hasEscompteGreaterThanRemise = produits.some(
                (product) =>
                  (parseFloat(product.escompte) || 0) >
                  (parseFloat(product.Remise) || 0)
              );

              const alertMessage = hasEscompteGreaterThanRemise
                ? "Escompte supérieur à la remise"
                : !checkIfAllEscompteLessThan20P(el.Rapport)
                ? "Escompte élevé (> 20%)"
                : null;

              return (
                <ReportCard
                  key={el._id}
                  report={el}
                  documentNumber={el.RBC}
                  status={el.EtatMagasinier}
                  docTypes={Object.getOwnPropertyNames(el.Rapport)}
                  alertMessage={alertMessage}
                  canUpdate={accessList.Validation}
                  onOpen={() => handleOpenReportDetails(el._id)}
                  onValidate={() => handleValidateModale(el._id)}
                  onCancel={() => handleCancelReport(el._id)}
                />
              );
            })}
          </div>
        )}
      </div>

      {!isLoading && numberOfReports != 0 && (
        <div className="mt-4 flex items-center gap-4">
          <Button
            variant="text"
            className="flex items-center gap-2"
            onClick={prev}
            disabled={currentPagination === 1}
          >
            <IoMdArrowDropleftCircle size={30} />
          </Button>
          <div className="flex items-center gap-2">
            {currentPagination !== numberOfPaginations
              ? // paginations row
                Array.from({
                  length: numberOfPages > 5 ? 5 : numberOfPages,
                }).map((el, index) => {
                  const pageNumber = index + 1 + (currentPagination - 1) * 5;
                  return (
                    <IconButton {...getItemProps(pageNumber)}>
                      {pageNumber}
                    </IconButton>
                  );
                })
              : // last pagination row
                Array.from({ length: numberOfPages % 5 }).map((el, index) => {
                  const pageNumber = index + 1 + (currentPagination - 1) * 5;
                  return (
                    <IconButton {...getItemProps(pageNumber)}>
                      {pageNumber}
                    </IconButton>
                  );
                })}
          </div>
          <Button
            variant="text"
            className="flex items-center gap-2"
            onClick={next}
            disabled={
              currentPagination === numberOfPaginations ||
              numberOfPaginations === 0
            }
          >
            <IoMdArrowDroprightCircle size={30} />
          </Button>
        </div>
      )}
    </>
  );
}

export default BeforeInvoce;
